import { Lock } from 'lucide-react';

interface FeatureDisabledBannerProps {
  featureKey: string;
  featureName: string;
  description?: string;
}

const featureDescriptions: Record<string, string> = {
  suricata: 'Suricata IDS/IPS provides network intrusion detection and prevention, security alerting, and threat analysis.',
  wireguard_iot: 'WireGuard IoT Gateway enables secure VPN tunnels for IoT gateway devices such as GL.iNet Opal routers.',
};

export default function FeatureDisabledBanner({ featureKey, featureName, description }: FeatureDisabledBannerProps) {
  const desc = description || featureDescriptions[featureKey] || '';

  return (
    <div className="rounded-lg border-2 border-amber-300 bg-amber-50 p-6">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 rounded-full bg-amber-100 p-3">
          <Lock className="h-6 w-6 text-amber-600" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-amber-900">
            {featureName} is not included in your current plan
          </h3>
          {desc && (
            <p className="mt-1 text-sm text-amber-700">{desc}</p>
          )}
          <p className="mt-3 text-sm text-amber-800">
            Additional licensing is required to enable this feature.
            Contact your Account Manager for more information.
          </p>
        </div>
      </div>
    </div>
  );
}
